import type { HtmlFragmentDefinition, HtmlTagDefinition } from '#shared/model/html'

function setLinksTargetInTag(tag: HtmlTagDefinition): HtmlTagDefinition {
  if (tag.tag === 'a') {
    return {
      ...tag,
      attrs: {
        ...tag.attrs,
        target: '_blank',
      },
    }
  }

  const newTag = {
    ...tag,
  }

  if (newTag.content) {
    newTag.content = setLinksTarget(newTag.content)
  }

  return newTag
}

export function setLinksTarget(bbCode: HtmlFragmentDefinition): HtmlFragmentDefinition {
  if (!bbCode || typeof bbCode === 'string' || typeof bbCode === 'number') return bbCode

  if (Array.isArray(bbCode)) {
    const transformedBbCode = []

    for (const node of bbCode) {
      if (!node || typeof node === 'string' || typeof node === 'number') {
        transformedBbCode.push(node)
        continue
      }

      transformedBbCode.push(setLinksTargetInTag(node))
    }

    return transformedBbCode
  }

  return setLinksTargetInTag(bbCode)
}

export function postTransformBbCode(bbCode: HtmlFragmentDefinition) {
  bbCode = setLinksTarget(bbCode)
  return bbCode
}
